import moment from 'moment'
import React from 'react'
import { Tooltip } from '../../../../shared/components/text/tooltip/Tooltip'
import { IconWarningCircle } from '../../../../shared/components/icons/IconWarningCircle'
import { IconInfoCircle } from '../../../../shared/components/icons/IconInfoCircle'
import { IconWarning } from '../../../../shared/components/icons/IconWarning'
import { useTranslation } from 'react-i18next'

interface LastFoundCellProps {
  lastFound: string
}

const EXACT_FORMAT = 'DD MMM YYYY, HH:mm'

export const LastFoundCell = ({ lastFound }: LastFoundCellProps) => {
  const { t } = useTranslation()
  const date = moment(lastFound)

  if (!date.isValid()) {
    return <span>{lastFound}</span>
  }

  const hours = moment().diff(date, 'hours')

  let label: string

  if (hours < 24) {
    label = t('pages.trademarkInfringements.lastFound.today')
  } else if (hours < 48) {
    label = t('pages.trademarkInfringements.lastFound.yesterday')
  } else {
    label = t('pages.trademarkInfringements.lastFound.countDaysAgo', {
      count: moment().diff(date, 'days'),
    })
  }

  return (
    <Tooltip placement='topLeft' title={date.format(EXACT_FORMAT)}>
      <div className={'flex items-center gap-[4px]'}>
        <div className={'w-[16px]'}>
          {hours < 24 ? (
            <IconWarningCircle color={'#FF2450'} />
          ) : hours < 48 ? (
            <IconWarning color={'#BDAA00'} />
          ) : (
            <IconInfoCircle color={'#A89ABB'} />
          )}
        </div>
        <span className={'underline decoration-dotted'}>{label}</span>
      </div>
    </Tooltip>
  )
}
